import { render, staticRenderFns } from "./InspectionDetail.vue?vue&type=template&id=681e6f06&scoped=true&"
import script from "./InspectionDetail.vue?vue&type=script&lang=js&"
export * from "./InspectionDetail.vue?vue&type=script&lang=js&"
import style0 from "./InspectionDetail.vue?vue&type=style&index=0&id=681e6f06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681e6f06",
  null
  
)

export default component.exports